var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table-filters',{attrs:{"filters":_vm.filterDefs,"without-title":""},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }